// Legacy alias — canonical module lives at /automations (P2 rename).
import { Redirect } from 'expo-router';

export default function PathsIndexAlias() {
    return <Redirect href="/automations" />;
}
